<template>
  <div>
    <Head title="Verifikasi Rencana Anggaran Beasiswa" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/verify-accountability-reports">
        Verifikasi Rencana Anggaran Beasiswa {{ jenisBeasiswa }}
      </Link>
      <span class="font-medium text-indigo-400">/</span>
      {{ application.nama }}
    </h1>
    <div class="w-full mb-8 bg-white rounded-md shadow">
      <div class="flex justify-between w-full px-8 py-6 bg-gray-200">
        <h2 class="text-xl">Informasi Rencana Anggaran Beasiswa</h2>
        <div class="flex">
          <Button
            v-if="canWrite('verify permohonan beasiswa') "
            type="button" class="mr-2 btn-green" @click.prevent="verifyApplication"
          >
            <span><font-awesome-icon icon="fas fa-check" class="mr-2" />Terima</span>
          </Button>
          <Button
            v-if="canWrite('verify permohonan beasiswa') " type="button"
            class="mr-2 btn-warning" @click.prevent="cancelApplication"
          >
            <span><font-awesome-icon icon="fas fa-ban" class="mr-2" />Tolak</span>
          </Button>
        </div>
      </div>
      <div class="flex w-full">
        <dl class="flex flex-wrap w-full p-6 leading-10 lg:w-1/2">
          <dt class="w-full lg:w-3/12">NIM Pemohon</dt>
          <dd class="w-full lg:w-9/12">: {{ application.nim }}</dd>
          <dt class="w-full lg:w-3/12">Nama Pemohon</dt>
          <dd class="w-full lg:w-9/12">: {{ application.nama }}</dd>
          <dt class="w-full lg:w-3/12">Nama Universitas</dt>
          <dd class="w-full lg:w-9/12">: {{ application.nama_universitas }}</dd>
          <dt class="w-full lg:w-3/12">Program Studi</dt>
          <dd class="w-full lg:w-9/12">: {{ application.nama_prodi }}</dd>
          <dt class="w-full lg:w-3/12">Jenis Beasiswa</dt>
          <dd class="w-full lg:w-9/12">: {{ jenisBeasiswa }} {{ application.jenis_pt }} {{ application.jenis }}</dd>
        </dl>
        <div class="flex flex-wrap w-full p-6 leading-10 lg:w-1/2">
          <dt class="w-full lg:w-4/12">Semester</dt>
          <dd class="w-full lg:w-8/12">: {{ application.semester }}</dd>
          <dt class="w-full lg:w-4/12">Nilai IPK</dt>
          <dd class="w-full lg:w-8/12">: {{ application.ipk }}</dd>
          <dt class="w-full lg:w-4/12">No Rekening</dt>
          <dd class="w-full lg:w-8/12">: {{ application.account_number }}</dd>
          <dt class="w-full lg:w-4/12">Nominal Beasiswa</dt>
          <dd class="w-full lg:w-8/12">:  {{ formatCurrency(nominalBeasiswa) }}</dd>
          <dt class="w-full lg:w-4/12">Total Anggaran</dt>
          <dd class="w-full lg:w-8/12">: {{ formatCurrency(totalAnggaran) }}</dd>
        </div>
      </div>
    </div>
    <div class="w-full mt-8 bg-white rounded-md shadow">
      <div class="flex justify-between w-full px-8 py-6 bg-gray-200">
        <h2 class="text-xl">Rincian Rencana Anggaran</h2>
      </div>

      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Jenis </th>
            <th class="px-6 pt-6 pb-4">Uraian</th>
            <th class="px-6 pt-6 pb-4 text-right">Nominal</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="detail in application.details" :key="detail.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="p-2 pl-6 border-t">
              <p class="font-semibold">{{ detail.category }}</p>
            </td>
            <td class="p-2 border-t">
              {{ detail.description }}
            </td>
            <td class="p-2 text-right border-t">
              {{ formatCurrency(detail.nominal_rab) }}
            </td>
          </tr>
          <tr v-if="application.details.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write permohonan beasiswa')? 5 : 4">Tidak ada data penggunaan anggaran yang diupload.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    application: Object,
    jenisBeasiswa: String,
    nominalBeasiswa: Number,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        scholar_application_id: this.application.id,
        type: null,
        file: null,
      }),
      imageData: '',
      statusInput: false,
      imageSource: '',
      showImage: false,
      catatan_verifikasi: '',
    }
  },
  computed: {
    isPenolakanAktif() {
      var validity = false
      if(this.totalAnggaran < this.nominalBeasiswa)
        validity = true
      return validity
    },

    totalAnggaran() {
      return this.application.details.reduce((sum, detail) => sum + (Number(detail.nominal_rab) || 0), 0)
    },
  },

  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) {
        return 'Rp 0'
      }
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value)
    },
    verifyApplication() {
      this.$swal.fire({
        title: 'Anda yakin setujui permohonan anggaran beasiswa ini?',
        text: 'Harap verifikasi ulang sebelum merubah status!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.put(`/accountability-reports/${this.application.id}/verify`)
        }
      })
    },
    async cancelApplication() {
      const { value: catatan } = await this.$swal.fire({
        title: 'Anda yakin batalkan permohonan anggaran beasiswa ini?',
        input: 'text',
        inputLabel: 'Masukan Alasan Pembatalan',
        inputValue: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
        inputValidator: (value) => {
          if (!value) {
            return 'Catatan verifikasi harus diisi!'
          }
        },
      })

      if (catatan) {
        this.$inertia.put(`/accountability-reports/${this.application.id}/cancel`, {
          'catatan_verifikasi': catatan,
        })
      }
    },

  },
}
</script>
